"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScaleConditional = void 0;
var _react = require("react");
var _useScaleDensity = require("./useScaleDensity");
/**
 * Conditionally return a value based on scale density.
 * @param config: An object with light and dark keys.
 * @returns value: The value to return when it's key is active.
 */
const useScaleConditional = ({
  dense,
  normal
}) => {
  const density = (0, _useScaleDensity.useScaleDensity)();
  return (0, _react.useMemo)(() => {
    return density === 'dense' ? dense : normal;
  }, [density, dense, normal]);
};
exports.useScaleConditional = useScaleConditional;